import { Clearance } from "@/models/clearance.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";
import { InvoiceLine } from "@/models/invoice-line.entity";
import clearanceRequestService from "@/services/mrfiktiv/services/clearance-request.service";
import { $t } from "@/lib/utility/t";

export class ClearanceFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.CLEARANCE;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.CLEARANCE, async () => {
      const response = await clearanceRequestService.getDocumentBySharedAccessToken(partnerId, refId, sct);
      const request = new Clearance(response);

      // Add default first position to request
      if (!request.lineItems || !request.lineItems.length) {
        request.lineItems = [
          new InvoiceLine({
            title: $t("clearance.defaultPosition").toString()
          })
        ];
      }

      return request;
    });
  }
}
